// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1-R7N","title":"Info_title__3ftkY","selects":"Info_selects__18tQ-","requiredAsterisk":"Info_requiredAsterisk__Zvbyo"};